import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "fill-height pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('niota-classic-gw-mgmt-map-instance', {
    ref: "mapInstance",
    attrs: {
      "items": _vm.gwItems,
      "clusters": _vm.gwClusters,
      "cameraObj": _vm.camera
    },
    on: {
      "map-moved": e => _vm.loadGWs(e.bounds)
    },
    scopedSlots: _vm._u([{
      key: "bottom",
      fn: function () {
        return [_c('div', {
          staticClass: "mapLayerControl",
          staticStyle: {
            "z-index": "5"
          }
        }, [_c(VRow, {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex",
            "flex-direction": "row",
            "justify-content": "flex-start",
            "align-items": "center",
            "min-width": "650px"
          },
          attrs: {
            "align": "center"
          }
        }, [_c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.back'),
            "prepend-icon": "fa-arrow-alt-left"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push({
                path: `/niota-classic/${_vm.$route.query.monitoring !== undefined ? 'device-monitoring' : 'gw-mgmt'}`
              });
            }
          }
        })], 1), _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel'),
            "prepend-icon": "fa-siren-on",
            "color": _vm.filterWarning ? 'warning' : _vm.color,
            "solid-icon": _vm.filterWarning
          },
          on: {
            "click": function ($event) {
              _vm.filterWarning = !_vm.filterWarning;
              _vm.filterAlert = false;
            }
          }
        })], 1), _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel'),
            "prepend-icon": "fa-exclamation-triangle",
            "color": _vm.filterAlert ? 'danger' : _vm.color,
            "solid-icon": _vm.filterAlert
          },
          on: {
            "click": function ($event) {
              _vm.filterAlert = !_vm.filterAlert;
              _vm.filterWarning = false;
            }
          }
        })], 1)])], 1)];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };